import routes from 'pages/fatal-accident-claims/dependency/routes';
import stepGenerator, {buildFromRoute} from 'store/generators/step';

/**
 * All steps are defined on the routes and set here.
 * @type {Array}
 */
const steps = routes.children.map(route => {
    return buildFromRoute({ route, prefix: 'fatal-accidents' });
});

// Use the generator to create a namespaced set of routes for fatal module
export default stepGenerator(steps);



// WEBPACK FOOTER //
// ./src/store/modules/fatal/dependency/step.js